import { useNavigate } from 'react-router-dom';
import Button, { CustomButtonProps } from '../Button';
import useLocale from '../../../hooks/useLocale';

const CancelButton = ({ padding = 'large', onClick, className, ...props }: CustomButtonProps): JSX.Element => {
  const { t } = useLocale();
  const navigate = useNavigate();

  return (
    <Button
      // className={className}
      kind="cancel"
      padding={padding}
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        } else {
          navigate(-1);
        }
      }}
      {...props}
    >
      {t.CANCEL}
    </Button>
  );
};

export default CancelButton;
